module.exports = __webpack_public_path__ + "static/media/minus-red.0232a049.svg";